<template>
        <a-card class="card-border" style="border: 0px; border-bottom: 1px solid #e1e4e8;" :bodyStyle="{padding: '10px', textAlign: 'left'}">
          <a-row>
            <a-col :span="24">
              <h3 style="text-align: right;">
                <a @click="showDetails(index)" style="float: left; text-align: left"> {{item.title}}</a>

                <a-tag color="green"  v-if="item.status == 'pre'">预招标</a-tag>
                <a-tag color="#2db7f5" style=""  v-if="item.status == 'announce' || item.status == 'update' || item.status == 'review'">招标中</a-tag>
                <a-tag color="#242424"  v-if="item.status == 'result' || item.status == 'deal'">招标结束</a-tag>
                <a-tag color=""  v-if="item.status == 'terminate'">招标终止</a-tag>

                <a-checkbox @change="linkChange($event)" :key="refresh" :checked="item.checked"></a-checkbox>
              </h3>
            </a-col>
          </a-row>
          <a-row>
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="text-align: left; margin-bottom: 4px">
              招标单位：{{item.buyer_name }}
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="text-align: left; margin-bottom: 4px">
              招标地点：{{item.location}}
            </a-col>
            <a-col :span="24">
              <p class="text-split"> 项目内容：{{item.content}}</p>
            </a-col>
          </a-row>
          <bidding-tab v-if=" showdetail && versions && versions.length > 0" :items="versions" v-bind:disabled="getVersions"/>
          <comments @following="followItem" @deleteitem="deleteComments" @additem="addComments" :key="refresh" :index="index" :item="item" :Ent_tag="0"/>
        </a-card>
</template>

<script>
import {BiddingTab, Comments} from '@/com/Basic'

export default {
  name: 'BiddingItem',
  props: {
    item: {
      default: function() {
        return {}
      }
    },
    index: {
      type: Number,
      default: function() {
        return 0
      }
    }
  },
  data() {
    return {
      versions: this.item.data,
      showdetail: this.item.showdetail,
      refresh: 1
    }
  },
  components: {
    BiddingTab,
    Comments
  },
  filters: {
    TimeChange(value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      return y + "-" + MM + "-" + d;
   }
  },
  computed: {
    getVersions: function() {
      this.versions = this.item.data;
      this.showdetail = this.item.showdetail;
    }
  },
  methods: {
    linkChange: function(e) {
      let item = this.item
      if (e.target.checked) {
         this.$emit('linkchange', this.item.bid_id, true, item.title);
         item["checked"] = true;
         this.$set(item, 'checked', true);
         this.item = item;
      } else {
         this.$emit('linkchange', this.item.bid_id, false, item.title);
         item["checked"] = false;
         this.$set(item, 'checked', false);
         this.item = item;
      }
      this.refresh += 1;
      this.$store.commit('updateresultitem', {result: this.item, index: this.index});
    },
    followItem: function(item, value) {
      item.profile['like'] = value;
      let postdata = {
            "task": "ADD_PROFILE_LIKE",
             type: 'bidding',
             source: item.bid_id,
             like: value
          };
      let that = this;
      that.post("profile", postdata)
        .then(function(response) {
          that.item = item;
          that.$store.commit('updateresultitem', {result: that.item, index: that.index});
          that.refresh += 1;
        }).catch(function (e) {
          that.$message.error('修改失败');
     });
    },
    addComments: function(content, item) {
      let postdata = {
        task: "ADD_PROFILE_COMMENT",
        type: "bidding",
        source: item.bid_id,
        content: content
      };
      let that = this;
      that.post("profile", postdata)
        .then(function(data) {
          if (!item.profile) {
            item.profile = {};
          }
          if (!item.profile.comments) {
            item.profile.comments = [];
          }
          item.profile.comments.push({"content": content, "time": (new Date()).valueOf()});
          that.item = item;
          that.$store.commit('updateresultitem', {result: that.item, index: that.index});
          that.refresh += 1;
        }).catch(function (e) {
          console.log(e);
          that.$message.error("添加失败");
      })
    },
    deleteComments: function(item, order) {
      let postdata = {
        task: "DELETE_PROFILE_COMMENT",
        type: "bidding",
        source: item.bid_id,
        order: order
      };
      let that = this;
      that.post("profile", postdata)
        .then(function(data) {
          let tp = item["profile"];
          let comments = [];
          for (let i = 0; i < tp.comments.length; i++) {
            if (i != Number(order)) {
              comments.push(tp.comments[i]);
            }
          }
          item["profile"]["comments"] = comments;
          that.item = item
          that.$store.commit('updateresultitem', {result: that.item, index: that.index});
          that.refresh += 1;
        }).catch(function (e) {
          console.log(e);
          that.$message.error("添加失败");
      })
    },
    showDetails: function() {
      let item = this.item;
      if (item["showdetail"] && item["showdetail"] == true) {
        item["showdetail"] = false;
        this.showdetail = false;
        this.item = item;
        this.$store.commit('updateresultitem', {result: this.item, index: this.index});
        return;
      }
      if (item["showdetail"] && item["showdetail"] == false) {
        item["showdetail"] = true;
        this.showdetail = true;
        this.item = item;
        this.$store.commit('updateresultitem', {result: this.item, index: this.index});
        return;
      }
      let bid_id = item.bid_id;
      let postdata = {
        "task": "BID_TASK_DETAIL",
        "bid_id": bid_id
      };
      let that = this;
      let loading = that.$message.loading("详细数据获取中...", 0);
      that.post('bidding', postdata)
        .then(function(data) {
          setTimeout(loading, 0);
          data.data["like"] = item.like ? item.like: 0;
          data.data["profile"] = item.profile ? item.profile: {};
          let tp = item;
          tp["showdetail"] = true;
          tp["data"] = data.data;
          that.item = tp;
          that.versions = data.data;
          that.showdetail = true;
          that.$store.commit('updateresultitem', {result: that.item, index: that.index});
        }).catch(function (e) {
          setTimeout(loading, 0);
          that.$message.error("查询失败");
      });
    }
  }
}
</script>

<style scoped>
  .pb8 {
    padding-bottom: 8px;
  }
  .card-border {
    border-top: 0px;
    border-bottom: 1px solid #e1e4e8;
    border-left: 0px;
    border-right: 0px;
  }
  .text-split {
    font-size: 14px;
    word-break:break-all;
    display:-webkit-box;
    -webkit-line-clamp:2;
    -webkit-box-orient:vertical;
    overflow:hidden;
  }
  .mb4 {
    margin-bottom: 4px;
  }
</style>
